// @flow
import { Datepicker } from 'fg-frontend/src/components/Datepicker';
import { Slovak } from "flatpickr/dist/l10n/sk";
import moment from "moment";

class CustomDatePicker extends Datepicker {

}

CustomDatePicker.defaultProps = {
	hideTimeout: 200,
	locale: Slovak,
	allowInput: true,
	altInput: false,
	dateFormat: 'd. m. Y',
	disableMobile: "true",
	time_24hr: true,
	minuteIncrement: 5,
	hourIncrement: 1,
	altFormat: 'd. m. Y',
	onChange: function(selectedDates, dateStr, instance) {
		instance.element.parentElement.parentElement.parentElement.classList.remove('filter-date-input--active');
	},
	parseDate: (datestr, format) => {
		return moment(datestr, "DD.MM.YYYY").toDate();
	}
};

export default CustomDatePicker;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/CustomDatePicker.js